"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatsLoader = void 0;
var _featureToggles = require("@ori/feature-toggles");
var _webMessenger = require("@ori/web-messenger");
var _WebMessenger = require("../../spas/WebMessenger");
var _ChatFeature = require("./ChatFeature");
var _jsxRuntime = require("react/jsx-runtime");
const ChatsLoader = ({
  webMessengerProps
}) => {
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const isWebMessengerEnabled = isFeatureEnabled(_ChatFeature.ChatFeature.UseWebMessenger);
  const useWebMessengerAsClientApp = isFeatureEnabled(_ChatFeature.ChatFeature.UseWebMessengerAsClientApp);
  if (!isWebMessengerEnabled) {
    return null;
  }
  return useWebMessengerAsClientApp ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_WebMessenger.WebMessenger, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_webMessenger.WebMessengerController, {
    ...webMessengerProps
  });
};
exports.ChatsLoader = ChatsLoader;
